import { render } from "./zhuzhizhongyi-news.vue?vue&type=template&id=457c90cd&scoped=true"
import script from "./zhuzhizhongyi-news.vue?vue&type=script&lang=js"
export * from "./zhuzhizhongyi-news.vue?vue&type=script&lang=js"

import "./zhuzhizhongyi-news.vue?vue&type=style&index=0&id=457c90cd&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457c90cd"]])

export default __exports__